<script setup lang="ts">
const store = useBigHeroBannerStore();
const currentSlide = computed(() => store.currentSlideIndex + 1);
const numBanners = computed(() => store.banners.length);
const currentBanner = computed(() => store.banners[store.currentSlideIndex]);
const description = computed(() => {
  let text = "";
  switch (currentBanner.value.type) {
    case "ARTWORK":
      text = `${currentBanner.value.text.title} - ${currentBanner.value.text.subtitle}`;
      break;
    case "INTRO":
      text = ` ${currentBanner.value.text.title}:  ${currentBanner.value.text.lyrics},  ${currentBanner.value.text.chord}, ${currentBanner.value.text.lead}, ${currentBanner.value.text.vocal}. ${currentBanner.value.text.subtitle}`;
      break;
  }
  return text;
});
</script>

<template>
  <div
    class="sr-only"
    aria-live="polite"
    aria-atomic="true"
  >
    {{
      $t("SV.MES_SlideTitle", {
        current: currentSlide.toString(),
        total: numBanners.toString(),
        description: description,
      })
    }}
  </div>
</template>

<style scoped lang="postcss"></style>
